import { Observable } from 'rxjs';
import { QueryDefinition } from 'src/app/services/api.services';
import { VisualDataRequest } from '../../VisualDataRequest';
import { ChunkResult, RowsResult, VisualDataQueryStatus, VisualDataTableResourceOptions } from '../../VisualDataSource';
import { QueryState } from './QueryImpl';
import { ResourceKey } from './ResourceManagerImpl';

export abstract class DataQueryCache {
  abstract getOrAddQuery(request: VisualDataRequest): Promise<DataQueryCache.CachedQuery>;
  abstract tryUpdateQuery(request: VisualDataRequest, queryState: QueryState): Promise<DataQueryCache.CachedQuery>;
  abstract hasQuery(request: VisualDataRequest): Promise<boolean>;
  abstract removeQuery(request: VisualDataRequest): Promise<void>;
}

export namespace DataQueryCache {
  export type CachedQueryId = number;

  export interface CachedQuery {
    readonly status: CachedQueryStatus;
    readonly owned: boolean;
    readonly state: QueryState;
  }

  export enum CachedQueryStatus {
    AddedNew,
    ReplacedExpired,
    Updated,
    Returned,
  }

  export const none = new class extends DataQueryCache {
    async getOrAddQuery(request: VisualDataRequest): Promise<DataQueryCache.CachedQuery> {
      return {
        status: CachedQueryStatus.AddedNew,
        owned: true,
        state: { status: VisualDataQueryStatus.Requested }
      };
    }

    async tryUpdateQuery(request: VisualDataRequest, queryState: QueryState): Promise<DataQueryCache.CachedQuery> {
      return {
        status: CachedQueryStatus.AddedNew,
        owned: true,
        state: queryState
      };
    }

    async hasQuery(request: VisualDataRequest): Promise<boolean> {
      return false;
    }

    async removeQuery(request: VisualDataRequest): Promise<void> {
    }

    async getOrAddQueryResource(queryId: DataQueryCache.CachedQueryId, key: any): Promise<any> {
    }
  }();
}
